import { useSelector } from 'react-redux';
import FeatureFlags from '../feature-flags';

const useFeatureFlag = (featureFlag) => {
  const featureFlags = useSelector((state) => state.featureFlags);
  const featureFlagService = new FeatureFlags({ featureFlags });

  return featureFlagService.getFeatureFlag(featureFlag);
};

export default useFeatureFlag;
